module.exports = __webpack_public_path__ + "static/img/VDappScenarios3-1.3be6299.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/VDappScenarios3-1.png
// module id = 3QCF
// module chunks = 0